// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const chandler = defineModel({
  id: "chandler",
  batchId: "future",
  name: "Chandler",
  tags: ["building","chandler","low-poly","age-of-mcp","future"],
  summary: "Renders tallow and wax into candles and soap — light and hygiene.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.45, 0.45, 1.05), color: "#a8804a", position: [0, 0.365, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#7a5a30", position: [-0.725, 0.365, -0.525] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#7a5a30", position: [0.725, 0.365, -0.525] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#7a5a30", position: [-0.725, 0.365, 0.525] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#7a5a30", position: [0.725, 0.365, 0.525] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.75, 0.45, -0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.75, 0.45, -0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.75, 0.45, 0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.75, 0.45, 0.75] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.45, 0.85, 1.05), color: "#a8804a", position: [0, 0.565, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.85, 0.1), color: "#7a5a30", position: [-0.725, 0.565, -0.525] },
      { geometry: new THREE.BoxGeometry(0.1, 0.85, 0.1), color: "#7a5a30", position: [0.725, 0.565, -0.525] },
      { geometry: new THREE.BoxGeometry(0.1, 0.85, 0.1), color: "#7a5a30", position: [-0.725, 0.565, 0.525] },
      { geometry: new THREE.BoxGeometry(0.1, 0.85, 0.1), color: "#7a5a30", position: [0.725, 0.565, 0.525] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.35, 4), color: "#6b4a26", position: [-0.75, 0.675, -0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.35, 4), color: "#6b4a26", position: [0.75, 0.675, -0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.35, 4), color: "#6b4a26", position: [-0.75, 0.675, 0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.35, 4), color: "#6b4a26", position: [0.75, 0.675, 0.75] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.45, 0.85, 1.05), color: "#a8804a", position: [0, 0.565, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.85, 0.1), color: "#7a5a30", position: [-0.725, 0.565, -0.525] },
      { geometry: new THREE.BoxGeometry(0.1, 0.85, 0.1), color: "#7a5a30", position: [0.725, 0.565, -0.525] },
      { geometry: new THREE.BoxGeometry(0.1, 0.85, 0.1), color: "#7a5a30", position: [-0.725, 0.565, 0.525] },
      { geometry: new THREE.BoxGeometry(0.1, 0.85, 0.1), color: "#7a5a30", position: [0.725, 0.565, 0.525] },
      { geometry: new THREE.BoxGeometry(1.67, 0.07, 0.768678), color: "#7a4a36", position: [0, 1.19, 0.2925], rotation: [0.599744, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.67, 0.07, 0.768678), color: "#7a4a36", position: [0, 1.19, -0.2925], rotation: [-0.599744, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.69, 0.085, 0.085), color: "#5a3526", position: [0, 1.39, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.52, 0.05), color: "#5a4530", position: [0, 0.4, 0.535] },
      { geometry: new THREE.CylinderGeometry(0.2, 0.18, 0.34, 10), color: "#3c4146", position: [-0.62, 0.31, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.18, 0.18, 0.04, 10), color: "#e6d59a", position: [-0.62, 0.46, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.02, 0.02, 0.5, 6), color: "#8a5f33", position: [-0.78, 0.39, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.02, 0.02, 0.5, 6), color: "#8a5f33", position: [-0.46, 0.39, 0.5] },
      { geometry: new THREE.BoxGeometry(0.36, 0.03, 0.03), color: "#5f3f20", position: [-0.62, 0.64, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.015, 0.015, 0.16, 6), color: "#e6d59a", position: [-0.72, 0.56, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.015, 0.015, 0.16, 6), color: "#e6d59a", position: [-0.62, 0.56, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.015, 0.015, 0.16, 6), color: "#e6d59a", position: [-0.52, 0.56, 0.5] },
      { geometry: new THREE.BoxGeometry(0.22, 0.1, 0.22), color: "#bcae8c", position: [0.6, 0.19, 0.5] },
      { geometry: new THREE.BoxGeometry(0.22, 0.1, 0.22), color: "#bcae8c", position: [0.64, 0.29, 0.5] },
      { geometry: new THREE.BoxGeometry(0.22, 0.1, 0.22), color: "#bcae8c", position: [0.6, 0.39, 0.5] },
    ] },
  ],
  animations: [],
});
